import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import QuantityPicker from '@common/components/QuantityPicker';

export const QuantityText = styled.p`
  padding: 0 10px;
  font-size: 11px;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  flex-shrink: 0;

  ${media.md`
    padding-left: 50px;
  `}
`;

export const ProductQuantityPicker = styled(QuantityPicker)`
  padding: 0 20px;
  width: 100%;
`;

export const MetadataRow = styled.div`
  padding: 5px 0;
`;
